// ** react imports
import React from 'react';

// ** components imports
import QuestionHeader from './QuestionHeader';
import QuestionInput from './QuestionInput';
import QuestionDetails from './QuestionDetails';

// ** context imports
import { useQuiz } from '../../../../contexts/QuizContext';

const QuestionItem = ({ question }) => {
  const { control, errors, handleInputChange, isEditMode } = useQuiz();

  // Don't render hidden questions
  if (question.isHidden) return null;

  // Check if there's an error for this question
  const fieldError = errors && errors[question.questionId];
  const hasError = Boolean(fieldError);
  const errorId = hasError ? `qerr-${question.questionId}` : undefined;

  return (
    <div
      className={`border rounded-lg p-4 transition-colors ${
        hasError
          ? 'border-red-500 bg-red-50 dark:border-red-700 dark:bg-red-900/20'
          : question.unanswered
            ? 'border-red-200 bg-red-50 dark:border-red-700 dark:bg-red-900/20'
            : !question.isValid
              ? 'border-orange-200 bg-orange-50 dark:border-orange-700 dark:bg-orange-900/20'
              : 'border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-700/30'
      }`}
      role="group"
      aria-invalid={hasError || undefined}
      aria-describedby={errorId}
      data-question-id={question.questionId}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <QuestionHeader question={question} hasError={hasError} />

          <div className="">
            <QuestionInput
              data={question}
              control={control}
              errors={errors}
              handleInputChange={handleInputChange}
              isEditMode={isEditMode}
            />

            {/* Show error message if there is one */}
            {hasError && (
              <div
                id={errorId}
                className="mt-2 text-sm text-red-600 dark:text-red-400"
              >
                {errors?.[question.questionId]?.message}
              </div>
            )}

            <QuestionDetails question={question} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionItem;
